'use client'
import { useCallback, useState } from 'react'

import { useUsersByAreas } from '@/hooks/queries/users'

import {
  type AddResponsibleItem,
  ComboboxWorkflowResponsible,
  type Responsible,
} from './comboboxWorkflowResponsible'

type InviteResponsibleModalProps = {
  taskIndex: number
  onChange: (value: Responsible | null) => void
  responsible?: Responsible | null
  disabled: boolean
  areaIds?: string[]
}

const InviteResponsibleModal = ({
  onChange,
  responsible,
  disabled,
  areaIds,
}: InviteResponsibleModalProps) => {
  const [searchResponsible, setSearchResponsible] = useState('')

  const { users } = useUsersByAreas({ areaIds })

  const handleRemoveResponsible = useCallback(() => {
    onChange(null)
  }, [onChange])

  const handleAddResponsible = (item: AddResponsibleItem) => {
    onChange({
      id: item.value,
      name: item.label,
      avatar: item.avatar ?? null,
      area: item.area ?? null,
    })
    setSearchResponsible('')
  }

  return (
    <ComboboxWorkflowResponsible
      searchPlaceholder="Digite o nome do usuário"
      emptyMessage="Nenhum usuário encontrado"
      items={users.map((user) => ({
        value: user.value,
        label: user.label,
        avatar: user.avatar ?? null,
        area: user.area ?? null,
      }))}
      search={searchResponsible}
      selected={responsible}
      handleSearch={setSearchResponsible}
      handleSelect={handleAddResponsible}
      handleRemove={handleRemoveResponsible}
      disabled={disabled}
    />
  )
}
InviteResponsibleModal.displayName = 'InviteResponsibleModal'

export { InviteResponsibleModal }
